module.exports = __webpack_public_path__ + "img/carrousel-intervensionista-6.737f3323.png";